import RecentExerciseVideoSelectionASE from 'pages/Users/Detail/_components/RecentExerciseVideoSelection/RecentExerciseVideoSelectionASE';
import RecentExerciseVideoSelectionDAY from 'pages/Users/Detail/_components/RecentExerciseVideoSelection/RecentExerciseVideoSelectionDAY';

const RecentExerciseVideoSelection = (props) => {
  return (
    <div className="h-full w-full">
      <div className="flex flex-col space-y-5 h-full ">
        <div className="h-1/2 bg-white py-4 px-2 overflow-hidden">
          <RecentExerciseVideoSelectionDAY {...props} />
        </div>
        <div className="h-1/2 bg-white py-4 px-2 overflow-hidden">
          <RecentExerciseVideoSelectionASE {...props} />
        </div>
      </div>
    </div>
  );
};

export default RecentExerciseVideoSelection;
